<fui-rows [formGroup]="editService.formGroup">
    <ng-container formGroupName="receiptConfiguration">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-textarea-edit-control formControlName="header"
                                               [(ngModel)]="model.data.receiptConfiguration.header">
                    </wbo-textarea-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-textarea-edit-control formControlName="footer"
                                               [(ngModel)]="model.data.receiptConfiguration.footer">
                    </wbo-textarea-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column [label]="'wbo.company-details.edit.label.showOnReceipt'">
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="printCompanyName"
                                                   [(ngModel)]="model.data.receiptConfiguration.printCompanyName">
                        </wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="printPostcode"
                                                   [(ngModel)]="model.data.receiptConfiguration.printPostcode">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="printStreet"
                                                   [(ngModel)]="model.data.receiptConfiguration.printStreet">
                        </wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="printTelephone"
                                                   [(ngModel)]="model.data.receiptConfiguration.printTelephone">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="printSuburb"
                                                   [(ngModel)]="model.data.receiptConfiguration.printSuburb">
                        </wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="printAbn"
                                                   [(ngModel)]="model.data.receiptConfiguration.printAbn">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="printState"
                                                   [(ngModel)]="model.data.receiptConfiguration.printState">
                        </wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="printGstNumber"
                                                   [(ngModel)]="model.data.receiptConfiguration.printGstNumber">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                </fui-column>
                <fui-column [label]="'wbo.company-details.edit.label.printingOptions'">
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="printLargeOrderName"
                                                   [(ngModel)]="model.data.receiptConfiguration.printLargeOrderName">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                    <fui-tandem-field>
                        <!--<wbo-checkbox-edit-control formControlName="printBarcode" [(ngModel)]="model.data.receiptConfiguration.printBarcode">-->
                        <wbo-checkbox-edit-control formControlName="printFreeItems"
                                                   [(ngModel)]="model.data.receiptConfiguration.printFreeItems">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="itemiseExtras"
                                                   [(ngModel)]="model.data.receiptConfiguration.itemiseExtras">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="printForeignName"
                                                   [(ngModel)]="model.data.receiptConfiguration.printForeignName">
                        </wbo-checkbox-edit-control>
                    </fui-tandem-field>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-single-select-edit-control formControlName="userIdentifier"
                                                    [(ngModel)]="model.data.receiptConfiguration.userIdentifier"
                                                    [allowClearSelectionOption]="false">
                        <wbo-select-options>
                            <wbo-select-option
                                label="wbo.company-details.edit.option.useridentifier.none"></wbo-select-option>
                            <wbo-select-option
                                label="wbo.company-details.edit.option.useridentifier.userName"></wbo-select-option>
                            <wbo-select-option
                                label="wbo.company-details.edit.option.useridentifier.firstName"></wbo-select-option>
                            <wbo-select-option
                                label="wbo.company-details.edit.option.useridentifier.lastName"></wbo-select-option>
                            <wbo-select-option
                                label="wbo.company-details.edit.option.useridentifier.fullName"></wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </ng-container>
</fui-rows>
